import React, { useState } from 'react'
import NavBar from './NavBar'
import PhaTocText from 'assets/images/text_pha_toc.png'
import NguyenDucText from 'assets/images/text_nguyen_duc.png'
import NhaThoImg from 'assets/images/nha-tho-ho-tren-ban-ve.png'
import BannerLeft from 'assets/images/banner_left.png'
import BannerRight from 'assets/images/banner_right.png'
import BgIconBottom from 'assets/images/bg_icon_bottom.png'
import BgTrongDong from 'assets/images/vector-trong-dong-3.png'
import { Menu } from 'react-feather'
import NavBarMobile from './NavBarMobile'
import palette from 'core/constant/palette';

/**
 * `compact` asks for the short version of the banner: on a phone a bar with
 * the wordmark on one line and the menu button, elsewhere honoured only on
 * viewports that are actually short -- the rules live beside `.site-header`
 * in index.scss. Passing it on a full-height desktop screen changes nothing.
 */
const Header = ({ compact = false }: { compact?: boolean }) => {
    const [isShowMobileMenu, setIsShowMobileMenu] = useState<boolean>(false);
  return (
    <header className={`site-header${compact ? ' site-header--compact' : ''}
      bg-bg_brown w-full h-[300px] sm:h-[380px] md:h-[458px] flex flex-col items-center relative`}>
        <div className='container-base relative z-[11]'>
          <NavBar/>
        </div>
        <div className='header-place flex lg:hidden absolute top-5 items-center justify-center'>
          <span className='text-secondary text-sm font-light'>Huyện Yên Thành, Nghệ An</span>
        </div>
        {/* A `div` with an onClick: the only control that opens the menu on a
            phone, and neither Tab nor Enter could reach it. The offsets are
            picked so the 44px target keeps the icon exactly where it was. */}
        <button
        type='button'
        aria-label='Mở menu'
        aria-expanded={isShowMobileMenu}
        className='header-menu flex lg:hidden absolute top-1.5 right-1.5 h-11 w-11 items-center justify-center rounded-full
          focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'
        onClick={() => setIsShowMobileMenu(true)}
        >
          <Menu size={24} color={palette.gold}/>
        </button>
        {isShowMobileMenu &&
          <NavBarMobile handleClose={() => setIsShowMobileMenu(false)}/>
        }
        <div className='container-base relative z-[6]'>
            <div className='header-wordmark flex flex-col items-center z-10 absolute top-[56px] sm:top-[70px] md:top-[83px] mx-auto left-0 right-0'>
                <img src={PhaTocText} alt="Phả tộc" className='w-[140px] lg:w-[206px] h-[21px] lg:h-[30.69px]'/>
                <img src={NguyenDucText} alt="Nguyễn Đức" className='w-full max-w-[345px] sm:max-w-[400px] lg:max-w-[671.63px] h-auto mt-[9.31px]'/>
                
            </div>
            <img src={BgTrongDong} alt="" className='header-scene w-full h-full z-[1] absolute top-0 hidden md:block'/>
            <div className=' home-bg w-full h-full z-[2] absolute top-0'></div>
        </div>
        <img 
        src={BannerLeft} 
        alt="" 
        className='header-scene w-[11vw] h-auto min-[1598px]:w-[197.91px] min-[1598px]:h-[468px] absolute top-[87px] left-[66px] z-10 
          hidden md:block min-[1200px]:left-0 min-[1680px]:left-[10px] min-[1728px]:left-[66px]'/>
        <img 
        src={BannerRight} 
        alt="" 
        className='header-scene w-[11vw] h-auto min-[1598px]:w-[197.91px] min-[1598px]:h-[468px] absolute top-[87px] right-[66px] z-10 
          hidden md:block min-[1200px]:right-0 min-[1680px]:right-[10px] min-[1728px]:right-[66px]'/>
        <img src={BgIconBottom} alt="" className='header-band hidden md:block w-1/2 h-[127px] absolute bottom-0 left-0 z-[6] bg-bg_brown'/>
        <img src={BgIconBottom} alt="" className='header-band hidden md:block w-1/2 h-[127px] absolute bottom-0 right-0 z-[6] bg-bg_brown'/>
        <img src={BgIconBottom} alt="" className='header-band block md:hidden w-full h-[80px] absolute bottom-0 right-0 left-0 z-[6] bg-bg_brown'/>
        <img src={NhaThoImg} alt="Nhà thờ họ" className='header-scene w-full max-w-[458px] h-auto absolute bottom-[-30px] md:bottom-[-60px] z-10 md:ml-5 px-4 md:px-0'/>
    </header>
  )
}

export default Header